import React from 'react';
import {
  Dialog, DialogContent, DialogActions,
  Box, Typography, Button, Divider, Chip,
} from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import StarIcon from '@mui/icons-material/Star';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

const TYPE_EMOJI = {
  games: '🎮', consoles: '🕹️', lego: '🧱', movies: '🎬',
  music: '🎵', books: '📚', 'board-games': '🎲',
  'trading-cards': '🃏', manga: '📖', comics: '💥',
};

const MONTH_NAMES = ['January','February','March','April','May','June',
  'July','August','September','October','November','December'];

export default function RecapCard({ open, onClose, recap, year }) {
  if (!recap) return null;
  const { totalItems, topTypes, topGenres, longestStreakInYear, mostActiveMonth, reviewCount, photoCount } = recap;

  const activeMonthName = mostActiveMonth
    ? MONTH_NAMES[MONTH_NAMES.map(m => m.slice(0, 3)).indexOf(mostActiveMonth)] || mostActiveMonth
    : null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            width: 480,
            maxWidth: '100%',
            background: 'linear-gradient(135deg, #1a237e 0%, #311b92 100%)',
            color: '#fff',
            p: 4,
          }}
        >
          <Typography variant="overline" sx={{ opacity: 0.7, letterSpacing: 3 }}>InterCollect</Typography>
          <Typography variant="h4" fontWeight="bold" gutterBottom>{year} Year in Review</Typography>

          <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)', my: 2 }} />

          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h2" fontWeight="bold">{totalItems}</Typography>
            <Typography variant="body1" sx={{ opacity: 0.8 }}>items added to your collection</Typography>
          </Box>

          {topTypes.length > 0 && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="overline" sx={{ opacity: 0.6 }}>Top Collection Types</Typography>
              {topTypes.map(t => (
                <Box key={t.type} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}>
                  <Typography sx={{ textTransform: 'capitalize' }}>
                    {TYPE_EMOJI[t.type] || '📦'} {t.type.replace('-', ' ')}
                  </Typography>
                  <Chip label={t.count} size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff' }} />
                </Box>
              ))}
            </Box>
          )}

          <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)', my: 2 }} />

          <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', flexWrap: 'wrap', mb: 2 }}>
            <Box sx={{ textAlign: 'center' }}>
              <LocalFireDepartmentIcon sx={{ fontSize: 28 }} />
              <Typography variant="h6" fontWeight="bold">{longestStreakInYear}</Typography>
              <Typography variant="caption" sx={{ opacity: 0.7 }}>Day streak</Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <StarIcon sx={{ fontSize: 28 }} />
              <Typography variant="h6" fontWeight="bold">{reviewCount}</Typography>
              <Typography variant="caption" sx={{ opacity: 0.7 }}>Reviews</Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <CameraAltIcon sx={{ fontSize: 28 }} />
              <Typography variant="h6" fontWeight="bold">{photoCount}</Typography>
              <Typography variant="caption" sx={{ opacity: 0.7 }}>Photos</Typography>
            </Box>
          </Box>

          {topGenres.length > 0 && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="overline" sx={{ opacity: 0.6 }}>Top Genres</Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 0.5 }}>
                {topGenres.map(g => (
                  <Chip key={g.genre} label={`${g.genre} (${g.count})`} size="small"
                    sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff' }} />
                ))}
              </Box>
            </Box>
          )}

          {activeMonthName && (
            <Typography variant="body2" sx={{ opacity: 0.7, mt: 1 }}>
              🗓 Most active month: <strong>{activeMonthName}</strong>
            </Typography>
          )}

          <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)', my: 2 }} />
          <Typography variant="caption" sx={{ opacity: 0.5 }}>Take a screenshot to share your year!</Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
